import { isBefore, isAfter, startOfDay, endOfDay } from 'date-fns';
import { CALENDAR_TYPE } from 'app/config/calendar_type';
import { TYPE } from 'app/config/prescription_content';
import generateDates from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/utils/generateDates';
import setTimePerSpecificTime from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/utils/setTimePerSpecificTime';
import dateFormat from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/utils/dateFormat';
const schedulePerDaySpecificTime = function (padPrescription, pad) {
  // ***************************************************************************
  //                           VALIDATE PAD_PRESCRIPTION PARAMS
  // ***************************************************************************

  // TODO criar validação para o parâmetro

  const {
    //padPrescriptionId,
    //instruction,
    padPrescriptionSuggestionScheduling
    //
  } = padPrescription;

  // ***************************************************************************
  //                   GET PAD AND PAD_PRESCRIPTION INFORMATION
  // ***************************************************************************

  const { TIMES_PER } = CALENDAR_TYPE;
  //const cPadPrescription = await padPrescription.getByID(padPrescriptionId);

  const calendarType = TIMES_PER;
  const { /* padId, */ description, type } = padPrescription;

  let { startDate, endDate } = pad;

  const padStartDate = startOfDay(startDate);
  const padEndDate = endOfDay(endDate);

  // ***************************************************************************
  //                           VALIDATE PAD_PRESCRIPTION TYPE
  // ***************************************************************************

  // FIXME avaliar necessidade dessa verificação

  const { SUSPENDED } = TYPE;

  const isPadPrescriptionSuspended = type === SUSPENDED;

  if (isPadPrescriptionSuspended) return;

  // ***************************************************************************
  //             FIND PRESCRIPTION_CONTENT FROM PAD_PRESCRIPTION ID
  // ***************************************************************************

  //const pContent = await prescriptionContent.getOne({ padPrescriptionId });

  // ***************************************************************************
  //                   DATES TO SCHEDULE PRESCRIPTION
  // ***************************************************************************

  const now = new Date();
  const startDateToday = startOfDay(now);

  const {
    period,
    continuousUse,
    once
    // frequencyTypeId,
    // frequencyAmount,
    // frequency,
    // timeStart,
    // timeEnd,
  } = padPrescription;

  let dates = generateDates({
    period,
    continuousUse,
    once,
    startDate: startDateToday,
    endDate: padEndDate
  });

  dates = [...dates]
    // Removes date that are later than the padEndDate of Pad
    .filter(startDateTime => !isAfter(startOfDay(startDateTime), padEndDate))
    // Removes date that are before than the padStartDate of Pad
    .filter(startDateTime => !isBefore(startOfDay(startDateTime), padStartDate));

  // ***************************************************************************
  //                        SCHEDULE PRESCRIPTION CALENDAR
  // ***************************************************************************

  //const prescriptionContentId = pContent.id;
  let listPerDaySpecificTime = [];
  // eslint-disable-next-line
  for (let date of dates) {
    // eslint-disable-next-line
    for (const padPrescriptionSuggestion of padPrescriptionSuggestionScheduling) {
      const { applicationTime } = padPrescriptionSuggestion;

      const administrateDate = setTimePerSpecificTime(date, applicationTime);

      const insert = {
        //prescriptionContentId,
        calendarType,
        administrateDate,
        // shiftId,
        // administrateVisitationId,
        // aplicationDate,
        // aplicationVisitationId,
        // digitalSignature,
        // latitude,
        // longitude,
        description
      };

      listPerDaySpecificTime.push(insert);
    }
  }

  return dateFormat(listPerDaySpecificTime);
};

export default schedulePerDaySpecificTime;
